<template>
  <div id="app" style="overflow-x: hidden">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
    <modal
      :show.sync="$store.state.account.modals.subscribe"
      class="modal-default"
      :show-close="false"
      headerClasses="justify-content-center"
      style="padding-top: 100px;"
    >
      <p>{{$t('subscribe_desc')}}</p>
      <fg-input v-model="email" placeholder="Email"></fg-input>
      <template slot="footer">
        <n-button type="danger" @click="closeModal('subscribe')">{{$t('CLOSE')}}</n-button>
        <n-button type="success" @click="subscribe()"
          >{{$t('SUBSCRIBE')}}</n-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal, Button, FormGroupInput } from '@/components';
import config from "./config.js";
import axios from 'axios';

export default {
  components: {
    Modal,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
  data() {
    return {
      email: ''
    };
  },
  methods: {
    closeModal: function(modalName) {
      this.$store.commit(`closeModal`, modalName);
    },
    subscribe: async function() {
      let email = this.email.trim();
      if (email.length < 3) {
        alert(this.$t(`alert_invalid_email`));
        return;
      }
      let device = '';
      if (this.$device.mobile) {
        device = 'mobile/';
        if (this.$device.android || this.$device.androidPhone) {
          device += 'android';
        }
        else {
          device += 'ios';
        }
      }
      else {
        device = 'pc';
      }
      let parameters = JSON.parse(localStorage.parameters);
      let ret = await axios.post(`${config.api.stat_url}/preregist/subscribe`, {email: email, utm_source: parameters.utm_source, utm_medium: parameters.utm_medium, ref: parameters.ref, device: device, language: navigator.language, language2: this.$i18n.locale, from: 'homepage'});
      if (ret.data.result == false) {
        alert(this.$t(`alert_${ret.data.err.code}`));
      }
      else {
        alert(this.$t(`subscribe_ok`));
      }
      this.closeModal('subscribe');
    }
  }
}
</script>